import React from 'react'
import { Row } from 'react-foundation'

require('../style/css/third_party/foundation.css')
require('../style/css/third_party/animate.css')

require('../style/scss/custom/main.scss')

require('../style/css/custom/components/header.css')
require('../style/css/custom/cssAnimations.css')
require('../style/css/custom/main.css')

require('../js_animations/customAnimations.js')
require('../js_animations/scrollMagic.js')


const Header = ({
  myEmail,
  myPhone,
  logo_white_PNG,
  logo_blue_PNG_960,
  logo_blue_PNG_100,
  logo_blue_PNG_70,
  logo_blue_PNG_16,
  mouse_graphic_icon
}) => (

<div className="header " id="header">

  <div className="overlay" id="overlay">
    {
    // LOGO
    }
    <img src={logo_blue_PNG_100} alt="logo_small" className="overlay__logo" id="overlay_logo"/>
    {
    // WELCOME TO
    }
    <div className="overlay__header" id="overlay_header">
      <h6 className="animated bounceInDown" id="letter_1">W</h6><h6 className="animated bounceInDown" id="letter_2">E</h6><h6 className="animated bounceInDown" id="letter_3">L</h6><h6 className="animated bounceInDown" id="letter_4">C</h6><h6 className="animated bounceInDown" id="letter_5">O</h6><h6 className="animated bounceInDown" id="letter_6">M</h6><h6 className="animated bounceInDown" id="letter_7">E</h6> <h6 className="animated bounceInDown" id="letter_8">T</h6><h6 className="animated bounceInDown" id="letter_9">O</h6>
    </div>
    {
    // SONICLOUDS
    }
    <Row className="overlay__name" id="overlay__name">
      <div className="animated bounceInLeft letters" id="L1_S"><img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/Name_Letters/1_S.png" alt="S"/></div>
      <div className="animated bounceInDown letters" id="L2_O"><img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/Name_Letters/2_O.png" alt="O"/></div>
      <div className="animated bounceInLeft letters" id="L3_N"><img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/Name_Letters/3_N.png" alt="N"/></div>
      <div className="animated bounceInDown letters" id="L4_I"><img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/Name_Letters/4_I.png" alt="I"/></div>
      <div className="animated bounceInLeft letters" id="L5_C"><img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/Name_Letters/5_C.png" alt="C"/></div>
      <div className="animated bounceInDown letters" id="L6_L"><img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/Name_Letters/6_L.png" alt="L"/></div>
      <div className="animated bounceInRight letters" id="L7_O"><img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/Name_Letters/7_O.png" alt="O"/></div>
      <div className="animated bounceInDown letters" id="L8_U"><img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/Name_Letters/8_U.png" alt="U"/></div>
      <div className="animated bounceInRight letters" id="L9_D"><img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/Name_Letters/9_D.png" alt="D"/></div>
      <div className="animated bounceInRight letters" id="L10_S"><img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/Name_Letters/10_S.png" alt="S"/></div>
    </Row>

    <div className="animated fadeIn overlay__caption">
      {
      // Development and Design by David Chamberlin
      }
      <div id="caption_letters">

        <span id="caption_A"><h6 className="" id="caption_letter__1">D</h6><h6 className="" id="caption_letter__2">e</h6><h6 className="" id="caption_letter__3">v</h6><h6 className="" id="caption_letter__4">e</h6><h6 className="" id="caption_letter__5">l</h6><h6 className="" id="caption_letter__6">o</h6><h6 className="" id="caption_letter__7">p</h6><h6 className="" id="caption_letter__8">m</h6><h6 className="" id="caption_letter__9">e</h6><h6 className="" id="caption_letter__10">n</h6><h6 className="" id="caption_letter__11">t</h6> <h6 className="" id="caption_letter__12">a</h6><h6 className="" id="caption_letter__13">n</h6><h6 className="" id="caption_letter__14">d</h6> <h6 className="" id="caption_letter__15">D</h6><h6 className="" id="caption_letter__16">e</h6><h6 className="" id="caption_letter__17">s</h6><h6 className="" id="caption_letter__18">i</h6><h6 className="" id="caption_letter__19">g</h6><h6 className="" id="caption_letter__20">n</h6> <h6 className="" id="caption_letter__21">b</h6><h6 className="" id="caption_letter__22">y</h6></span> <h6 className="" id="caption_letter__23"><a href="https://www.linkedin.com/in/soniclouds">D</a></h6><h6 className="" id="caption_letter__24"><a href="https://www.linkedin.com/in/soniclouds">a</a></h6><h6 className="" id="caption_letter__25"><a href="https://www.linkedin.com/in/soniclouds">v</a></h6><h6 className="" id="caption_letter__26"><a href="https://www.linkedin.com/in/soniclouds">i</a></h6><h6 className="" id="caption_letter__27"><a href="https://www.linkedin.com/in/soniclouds">d</a></h6> <h6 className="" id="caption_letter__28"><a href="https://www.linkedin.com/in/soniclouds">C</a></h6><h6 className="" id="caption_letter__29"><a href="https://www.linkedin.com/in/soniclouds">h</a></h6><h6 className="" id="caption_letter__30"><a href="https://www.linkedin.com/in/soniclouds">a</a></h6><h6 className="" id="caption_letter__31"><a href="https://www.linkedin.com/in/soniclouds">m</a></h6><h6 className="" id="caption_letter__32"><a href="https://www.linkedin.com/in/soniclouds">b</a></h6><h6 className="" id="caption_letter__33"><a href="https://www.linkedin.com/in/soniclouds">e</a></h6><h6 className="" id="caption_letter__34"><a href="https://www.linkedin.com/in/soniclouds">r</a></h6><h6 className="" id="caption_letter__35"><a href="https://www.linkedin.com/in/soniclouds">l</a></h6><h6 className="" id="caption_letter__36"><a href="https://www.linkedin.com/in/soniclouds">i</a></h6><h6 className="" id="caption_letter__37"><a href="https://www.linkedin.com/in/soniclouds">n</a></h6>
      </div>
      {
      // (social icons)
      }
      <div className="header__social">
        <a href="https://www.linkedin.com/in/soniclouds" className="animate-shimmer"><img id="header__social_LI" src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Social/LinkedIn_5.png" alt="linkedin_icon" /></a>
        <a href="https://www.github.com/soniclouds" className="animate-shimmer"><img id="header__social_GH" src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/GitHub_6.png" alt="github_icon"/></a>
        <a href="https://www.facebook.com/starmachines" className="animate-shimmer"><img className="img_resize__sm" id="header__social_FB" src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Social/Facebook_4_crop.png" alt="facebook_icon" /></a>
      </div>
      {
      // Full Stack, Frontend...
      // }
      // <p>
      //   <span className="" id="word__1">Full</span> <span className="" id="word__2">Stack,</span> <span className="" id="word__3">Frontend</span><span className="" id="word__4">-driven</span> <span className="" id="word__5">Development</span> <span className="" id="word__6">for</span> <span className="" id="word__7">Web</span> <span className="" id="word__8">and</span> <span className="" id="word__9">Mobile</span> <span className="" id="word__10">specializing</span> <span className="" id="word__11">in</span> <span className="" id="word__12">UX</span><span className="" id="word__13">/UI</span> <span className="" id="word__14">and</span> <span className="" id="word__15">Interactive</span> <span className="" id="word__16">Design</span>
      // </p>
      }
    </div>
    {
    // closes overlay__caption
    }

  </div>
  {
  // closes overlay
  }

</div>

// closes header


)

export default Header



// WEBPACK FOOTER //
// ./src/components/header.js